import Contact from "./Contact";
import Favorites from "./Favorites";
import Publications from "./Publications";
import Home from "./Home";
import NotFound from "./NotFound";
import Search from "./Search";
import Cgv from "./Cgv";
import {
  ConfirmationToken,
  ForgotPasswordOrCode,
  Login,
  LoginForm,
  RegisterForm,
  Logout,
  ResettingPassword,
  Profile,
  ChangePassword,
  ChangeCode,
  AvatarForm
} from "./security";

export {
  Contact,
  Favorites,
  Publications,
  Home,
  Home as QrCode,
  ConfirmationToken,
  ForgotPasswordOrCode,
  Login,
  LoginForm,
  RegisterForm,
  Logout,
  ResettingPassword,
  Profile,
  ChangePassword,
  ChangeCode,
  Search,
  NotFound,
  AvatarForm,
  Cgv
};



// WEBPACK FOOTER //
// ./src/components/index.js